<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <dx-toolbar class="toolbar-details theme-dependent">
      <dxi-item location="before">
        <dx-button icon="arrowleft" stylingMode="text"></dx-button>
      </dxi-item>
      <dxi-item location="before" [text]="contactName"></dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <dx-button
          text="Terminate"
          type="default"
          stylingMode="contained"
        ></dx-button>
      </dxi-item>
      <dxi-item location="after">
        <dx-drop-down-button
          text="Actions"
          stylingMode="text"
          [items]="['Assign to Me', 'Archive']"
          [dropDownOptions]="{ width: 'auto' }"
        ></dx-drop-down-button>
      </dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <div class="separator"></div>
      </dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        [options]="{
          text: 'Copy',
          icon: 'copy',
          stylingMode: 'text'
        }"
      ></dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        [options]="{
          text: 'Refresh',
          icon: 'refresh',
          onClick: refresh,
          stylingMode: 'text'
        }"
      ></dxi-item>
    </dx-toolbar>

    <div class="panels theme-dependent">
      <div class="left">
        <contact-form
          [contactData]="contactData"
          [isLoading]="isLoading"
        ></contact-form>
      </div>

      <div class="right theme-dependent">
        <contact-cards
          [isLoading]="isLoading"
          [contactName]="contactData?.name"
          [tasks]="contactData?.tasks"
          [activities]="contactData?.activities"
          [activeOpportunities]="activeOpportunities"
          [closedOpportunities]="closedOpportunities"
          [notes]="contactNotes"
          [messages]="contactMessages"
        ></contact-cards>
      </div>
    </div>
  </div>
</dx-scroll-view>
